import { render, staticRenderFns } from "./RedeemCustomer.vue?vue&type=template&id=fdc5bcd2&scoped=true&"
import script from "./RedeemCustomer.vue?vue&type=script&lang=js&"
export * from "./RedeemCustomer.vue?vue&type=script&lang=js&"
import style0 from "./RedeemCustomer.vue?vue&type=style&index=0&id=fdc5bcd2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdc5bcd2",
  null
  
)

export default component.exports